export function parseJWT(token) {
  if (!token) {
    return null;
  }

  const arrayToken = token.split(".");
  const tokenPayload = JSON.parse(atob(arrayToken[1]));

  const isExpired = Math.floor(new Date().getTime() / 1000) >= tokenPayload?.sub;
  if (isExpired) {
    return null;
  }

  return tokenPayload;
}
